/* Farren — sepet çekmecesi "2'li" paket upsell'i + ödeme akışı sıralaması
   CRO teşhisi 25-26 Tem 2026.

   NEDEN VAR:
   PDP'de V187 "2 ve üzeri" rozeti çalışıyor ama sepet çekmecesinde paket
   teklifinin izi yoktu. Reklam ekonomisi tek adette çalışmıyor (CPA 3.158 TL,
   tek adet katkısı 1.427 TL), 2 adette çalışıyor (katkı 2.293 TL) — yani
   sepetin ikinci ürünü İSTEMESİ gerekiyor. Sepet, upsell için sitenin en
   verimli yüzeyi ve boş duruyordu.

   FİYAT FORMÜLÜ — `extensions/elbise-2li-indirim` Shopify Function'ı ve
   `snippets/farren-bulk-price-badge.liquid` ile BİREBİR AYNI olmalı:
     tek adet fiyatına düz %10 indirim (2.499,90 → 2.249,91). Yuvarlama YOK.
     Kapsam: `kampanya-2li` ETİKETİ
     Koşul : sepette kapsamdan en az 2 adet
   Oran / kapsam değişirse ÜÇÜ BİRDEN güncellenmeli; yoksa müşteri çekmecede
   bir fiyat görüp kasada başka öder.

   V457 (29 Ağu 2026) — İKİ SAPMA KAPATILDI. Bu dosya V321'de (oran %14,3 → %10,
   `...99,50` yuvarlaması kalktı) ve V344'te (kapsam "elbise + 2.499,90 üstü"
   olmaktan çıkıp `kampanya-2li` etiketine bağlandı) güncellenmemişti; Function
   ve rozet güncellenmiş, çekmece eski formülde kalmıştı. Canlıda ölçülen sonuç:
     2.499,90 TL elbise → rozet ve kasa 2.249,91 der, çekmece 2.099,50 diyordu.
     İki adette çekmece "800,80 TL kazanç" yazıyordu, gerçeği 499,98 TL.
   Yani çekmece kasadan 300,82 TL fazla vaat ediyordu — hem de doğru rakamı
   gösteren TOPLAM satırının hemen üstünde.

   Sapma neden 3 hafta fark edilmedi: doğrulama doğal olarak PDP rozetine
   bakıyor (rozetin doc bloğunda kendi tema tuzağı notu bile var) ve rozet
   doğruydu. Çekmece ayrı bir yüzey ve ayrı bir dosya. Oran değişirse
   `snippets/farren-bulk-price-badge.liquid` + `extensions/elbise-2li-indirim`
   + BU DOSYA üçü birlikte değişmeli.

   KAPSAM NEDEN FETCH İSTİYOR: kapsamın tek gerçek kaynağı `kampanya-2li`
   etiketi, ama `/cart.js` satırları etiket taşımaz (product_type taşır — eski
   kod da o yüzden tipe bakıyordu). Ürün başına `/products/<handle>.js` çekip
   etiketi okuyoruz, sonuç handle bazında önbelleğe alınıyor. İstek başarısız
   olursa ürün KAPSAM DIŞI sayılır: sessiz kalmak, yanlış fiyat vaat etmekten
   iyidir.

   Taban fiyat olarak `original_price` kullanılır: Function indirimi `/cart.js`
   satırındaki `price`'a YANSIMAZ (yalnız `total_price`'a düşer), ama sepette
   kupon varsa `price` kayar. `original_price` iki durumda da liste fiyatıdır.
*/
(function () {
  'use strict';

  // Function'ın uyguladığı düz %10'un çarpan hâli. Function `fiyat x 0,10`'u
  // kuruşa yuvarlayıp düşer, burada `fiyat x 0,90` alınır; katalogdaki fiyatlar
  // 10 kuruşun katı olduğu için iki hesap kuruşu kuruşuna aynıdır.
  var RATE = 0.90;
  var TAG = 'kampanya-2li';
  var COLLECTION = '/collections/kampanya-2li-elbise';
  var NODE_ID = 'frnBundleUpsell';

  // handle -> boolean (kapsamda mı). Bir kez çekilir, sekme boyunca durur.
  var scope = {};
  // handle -> uçuştaki istek. Ayrı tutulur: `scope`a "henüz bilmiyorum" diye
  // geçici `false` yazılırsa, istek dönmeden çalışan ikinci bir sync o değeri
  // KESİN cevap sanıp ürünü kapsam dışı sayar — sepette iki kampanya ürünü
  // varken tek ürün metni basılıyordu.
  var inflight = {};

  // V500 — sezon kapanışı "3 al %20" basamağı. Function (`kapanisAcik`) ve
  // rozetle aynı: kapsam `kampanya-3lu` etiketi, bu etiketten 3+ adette O
  // satırlar %20, mağaza saatiyle 15 Ekim 00:00'da kapanır.
  var RATE3 = 0.80;
  var TAG3 = 'kampanya-3lu';
  var KAPANIS_BITIS = Date.parse('2100-01-01T00:00:00+03:00') /* V532: bitiş tarihsiz */;
  var COLLECTION3 = '/collections/sezon-kapanisi';
  var scope3 = {};

  function bundlePrice(base) {
    return Math.round(base * RATE);
  }

  function money(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' TL';
  }

  function base(item) {
    return item.original_price || item.price || 0;
  }

  /* Sepetteki her farklı ürünün etiketini çeker; hepsi çözülünce döner.
     Aynı handle için ikinci istek açılmaz — uçuştaki söze eklenilir. */
  function loadScope(items) {
    var waits = [];

    items.forEach(function (it) {
      var h = it.handle;
      if (!h || Object.prototype.hasOwnProperty.call(scope, h)) return;

      if (!inflight[h]) {
        inflight[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            scope3[h] = !!(p && p.tags && p.tags.indexOf(TAG3) !== -1);
            scope[h] = !!(p && p.tags && p.tags.indexOf(TAG) !== -1);
          })
          .catch(function () { scope3[h] = false; scope[h] = false; })
          .then(function () { delete inflight[h]; });
      }
      waits.push(inflight[h]);
    });

    return waits.length ? Promise.all(waits) : Promise.resolve();
  }

  function build(cart) {
    var items = cart.items || [];

    return loadScope(items).then(function () {
      var lines = items.filter(function (it) {
        return scope[it.handle] === true || scope3[it.handle] === true;
      });
      var qty = lines.reduce(function (n, it) { return n + it.quantity; }, 0);
      if (qty < 1) return null;

      var acik = Date.now() < KAPANIS_BITIS;
      var qty3 = acik
        ? lines.reduce(function (n, it) { return n + (scope3[it.handle] === true ? it.quantity : 0); }, 0)
        : 0;

      // Satırın kasada düşeceği adet fiyatı — Function'la aynı karar.
      function linePrice(it) {
        return qty3 >= 3 && scope3[it.handle] === true
          ? Math.round(base(it) * RATE3)
          : bundlePrice(base(it));
      }

      if (qty >= 2) {
        var saved = lines.reduce(function (sum, it) {
          return sum + (base(it) - linePrice(it)) * it.quantity;
        }, 0);
        var html =
          '<div class="frnUpsell__title frnUpsell__title--on">' +
          (qty3 >= 3 ? '3\'lü fiyat uygulandı' : '2\'li fiyat uygulandı') + '</div>' +
          '<div class="frnUpsell__sub">Sepetinizde <b>' + money(saved) + '</b> kazanç var.</div>';
        if (qty3 === 2) {
          html +=
            '<div class="frnUpsell__sub">Sezon kapanışı parçalarından bir tane daha ekleyin, ' +
            'üçü de <b>%20</b> indirimli olsun.</div>' +
            '<a class="frnUpsell__cta" href="' + COLLECTION3 + '">Sezon kapanışı parçalarını gör →</a>';
        }
        return { sig: 'on:' + saved + ':' + qty3, html: html };
      }

      // Tek uygun ürün var — ikinciyi davet et.
      var it = lines[0];
      var unit = base(it);
      var drop = unit - bundlePrice(unit);
      var uclu = qty3 === 1;
      return {
        sig: 'off:' + unit + ':' + qty3,
        html:
          '<div class="frnUpsell__title">Bir parça daha ekleyin, ikisi de indirimli olsun</div>' +
          '<div class="frnUpsell__sub">Bu ürün <s>' + money(unit) + '</s> ' +
          '<b>' + money(bundlePrice(unit)) + '</b> — <b>' + money(drop) + '</b> kazanç. ' +
          'İkinci parça da kendi indirimli fiyatına düşer.' +
          (uclu ? ' Sezon kapanışı parçalarında 3 parçada <b>%20</b>.' : '') + '</div>' +
          '<a class="frnUpsell__cta" href="' + (uclu ? COLLECTION3 : COLLECTION) + '">' +
          (uclu ? 'Sezon kapanışı parçalarını gör →' : 'Kampanyadaki parçaları gör →') + '</a>'
      };
    });
  }

  var busy = false;

  function sync() {
    var foot = document.querySelector('.cartDrawer__foot');
    if (!foot || busy) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(build)
      .then(function (data) {
        // Kutu basılırken çekmece yeniden render olmuş olabilir; altlığı tazele.
        foot = document.querySelector('.cartDrawer__foot');
        if (!foot) return;

        var node = document.getElementById(NODE_ID);

        if (!data) {
          if (node) { busy = true; node.remove(); busy = false; }
          return;
        }
        // Aynı içerikse DOM'a dokunma — observer ile sonsuz döngüye girmeyelim.
        if (node && node.getAttribute('data-sig') === data.sig) return;

        busy = true;
        if (!node) {
          node = document.createElement('div');
          node.id = NODE_ID;
          node.className = 'frnUpsell';
          foot.insertBefore(node, foot.firstChild);
        }
        node.setAttribute('data-sig', data.sig);
        node.innerHTML = data.html;
        busy = false;
      })
      .catch(function () {});
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  }

  function start() {
    schedule();
    document.addEventListener('cart:updated', schedule);

    // Çekmece içeriği JS ile (farren-redesign-widgets.js) her açılışta yeniden
    // basılıyor; bizim düğüm siliniyor. Çekmeceyi izleyip yeniden ekliyoruz.
    var drawer = document.querySelector('.cartDrawer');
    if (!drawer) {
      // Çekmece henüz body'ye eklenmediyse, eklenmesini bekle.
      new MutationObserver(function (_m, obs) {
        if (document.querySelector('.cartDrawer')) { obs.disconnect(); start(); }
      }).observe(document.body, { childList: true });
      return;
    }
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
